import * as yup from 'yup';

export const categorySchema = yup.object({
  name: yup.string().required('Category name is required').min(2, 'Name must be at least 2 characters'),
  code: yup.string().required('Category code is required').min(2, 'Code must be at least 2 characters'),
  depreciation_rate: yup
    .number()
    .required('Depreciation rate is required')
    .min(0, 'Depreciation rate must be 0 or greater')
    .max(100, 'Depreciation rate cannot exceed 100%'),
  description: yup.string().optional(),
});
